import { useMemo } from 'react';
import type { ReactNode } from 'react';
import { RelayEnvironmentProvider } from 'react-relay';

import PixApp from './PixApp.tsx';
import { getEnv } from '../relay/Environment.tsx';
import useStoreContext from '../store/useStoreContext.tsx';

const PluginApp = (): ReactNode => {
  const { openPixState } = useStoreContext();

  const { config } = openPixState;

  // TODO consume appID from script params as well
  const environment = useMemo(() => {
    if (!config.appID) {
      return null;
    }

    const env = getEnv(config?.appID);

    if (window.$woovi) {
      window.$woovi.environment = env;
      window.$woovi.debugRelayStore = () => env.getStore().getSource().toJSON();
    }

    return env;
  }, [config?.appID]);

  // render an error
  if (!config?.appID) {
    return null;
  }

  return (
    <RelayEnvironmentProvider environment={environment}>
      <PixApp />
    </RelayEnvironmentProvider>
  );
};

export default PluginApp;
